import { useEffect, useRef, useState } from 'react';

// returns undefined if
// * nothing is stord in local storage
// * local storage has not been read yet
export function useLocalStorage<T>(
  key: string,
): [T | undefined, (value: T) => void] {
  const state = useState<{ value: T } | undefined>();
  const [valueStore, setValueStore] = state;

  const initialized = useRef(false);

  useEffect(() => {
    const item = window.localStorage.getItem(key);
    if (item) {
      const parsed: T = JSON.parse(item);
      setValueStore({ value: parsed });
    }

    initialized.current = true;
  }, [key, setValueStore]);

  useEffect(() => {
    if (valueStore === undefined) return;

    const value = valueStore.value;
    window.localStorage.setItem(key, JSON.stringify(value));
  }, [key, valueStore]);

  return [valueStore?.value, (value: T) => setValueStore({ value })];
}
